import type { Role } from "@/api/types";

/** Roles that may see other people's data in their organisation. */
export const STAFF: readonly Role[] = ["tenant_admin", "manager"];
/** Roles that exist inside an organisation. */
export const TENANT: readonly Role[] = ["tenant_admin", "manager", "employee"];

/**
 * "Access" is what a person may do in Zotula (the API's `role`). It is a fixed list.
 * "Role" in the console means the organisation's own job roles, which admins create.
 */
export const ROLE_LABEL: Record<Role, string> = {
  super_admin: "Platform admin",
  tenant_admin: "Admin",
  manager: "Manager",
  employee: "Employee",
};

/** Where each role lands after signing in. */
export function homePath(role: Role): string {
  if (role === "super_admin") return "/organisations";
  return role === "employee" ? "/my-day" : "/overview";
}
